import React from 'react';
import * as Icons from 'lucide-react';
import { INDUSTRIES } from '../mock';

const Industries = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0d3d5e]">
            Industries We Serve
          </h2>
          <p className="mt-4 text-slate-600 text-lg">
            From restaurants to aged care, Perth businesses across industries
            rely on our refrigerated transport.
          </p>
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {INDUSTRIES.map((ind) => {
            const Icon = Icons[ind.icon] || Icons.Building2;
            return (
              <div
                key={ind.title}
                className="p-6 rounded-lg border border-slate-100 bg-slate-50 hover:bg-white hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-md bg-[#0d3d5e] flex items-center justify-center">
                  <Icon className="w-6 h-6 text-white" />
                </div>
                <h3 className="mt-4 text-lg font-bold text-[#0d3d5e]">
                  {ind.title}
                </h3>
                <p className="mt-2 text-slate-600 text-sm leading-relaxed">
                  {ind.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Industries;
